import { PresetSummary } from "../model/analytics.types";
import DownloadIcon from "@/assets/icons/download.svg?react";
import CrownIcon from "@/assets/icons/crown.svg?react";
import GraphIcon from "@/assets/icons/graph.svg?react";
import { getErrorMessage } from "@/shared/lib/utils";
import { AxiosError } from "axios";
import { useTranslation } from "@/shared/i18n";

type Props = { 
  summary: PresetSummary | undefined;
  loading?: boolean;
  error?: AxiosError | null;
};

export function AnalyticsSummary({ summary, loading, error }: Props) {
  const { t } = useTranslation('analytics');
  
  if (error) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-8">
        <div className="bg-red-900/20 border border-red-500/20 rounded-lg p-5 col-span-full">
          <p className="text-red-400">{t('errorLoadingSummary')}: {getErrorMessage(error)}</p>
        </div>
      </div>
    );
  }

  const cards = [
    {
      label: t('freePresets'),
      value: summary?.totalFreePresets || 0,
      diff: `+12% ${t('vsPreviousPeriod')}`,
      color: "bg-[#22C55E33]",
      icon: DownloadIcon,
    },
    {
      label: t('paidPresets'),
      value: summary?.totalPaidPresets || 0,
      diff: `+8% ${t('vsPreviousPeriod')}`,
      color: "bg-[#3B82F633]",
      icon: CrownIcon,
    },
    {
      label: t('totalUses'),
      value: summary?.totalUses || 0,
      diff: `+11% ${t('vsPreviousPeriod')}`,
      color: "bg-[#A855F733]",
      icon: GraphIcon,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {cards.map((item) => {
        const Icon = item.icon;
        return (
          <div
            key={item.label}
            className={`bg-[#232323] border-none rounded-lg`}
          >
            <div className="p-5">
              <div className="flex items-center gap-3 mb-4">
                <span
                  className={`w-10 h-10 rounded-lg flex items-center justify-center ${item.color}`}
                >
                  <Icon />
                </span>
                <span className="text-white/60 text-sm">{item.label}</span>
              </div>
              <div className="text-2xl font-bold text-white mb-4 text-center">
                {loading ? (
                  <div className="h-8 bg-white/10 rounded animate-pulse"></div>
                ) : (
                  typeof item.value === "number"
                    ? item.value.toLocaleString("pt-BR")
                    : item.value
                )}
              </div>
              <div className={`w-full h-2 rounded m-auto ${item.color}`}>
                
              </div>
              {/* {item.diff && (
                <div className="text-green-400 font-normal text-sm">
                  {loading ? (
                    <div className="h-4 bg-white/10 rounded animate-pulse w-3/4"></div>
                  ) : (
                    item.diff
                  )}
                </div>
              )} */}
            </div>
          </div>
        );
      })}
    </div>
  );
}
